'use client';

import Image from 'next/image';
import Link from 'next/link';
import classes from './ValueGrid.module.scss';

type ValueCard = {
  title: string;
  description: string;
  icon?: string;
  tag?: string;
  linkLabel?: string;
  linkHref?: string;
};

type ValueGridProps = {
  title: string;
  subtitle?: string;
  cards: ValueCard[];
};

export const ValueGrid = ({ data }: { data: ValueGridProps }) => {
  const { title, subtitle, cards } = data;

  return (
    <section className={classes.section}>
      <div className={classes.header}>
        <div>
          <p className={classes.eyebrow}>Expertises</p>
          <h2>{title}</h2>
        </div>
        {subtitle && <p className={classes.subtitle}>{subtitle}</p>}
      </div>
      <div className={classes.cards}>
        {cards.map((card) => (
          <article key={card.title} className={classes.card}>
            {card.tag && <span className={classes.tag}>{card.tag}</span>}
            <div className={classes.cardBody}>
              {card.icon && (
                <span className={classes.iconWrapper}>
                  <Image src={card.icon} alt="" width={32} height={32} />
                </span>
              )}
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </div>
            {card.linkLabel && card.linkHref && (
              <Link href={card.linkHref} className={classes.link}>
                {card.linkLabel}
              </Link>
            )}
          </article>
        ))}
      </div>
    </section>
  );
};

